module.exports = __webpack_public_path__ + "static/media/icono-1.76b7b6a5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/gbadicionales/icono-1.svg
// module id = 753
// module chunks = 0